export const getRowsFromData = (obj) => {
	const isObject = (obj) => typeof obj === "object" && obj !== null;
	let rows = [];
	obj?.oems?.forEach?.((oemEntry, index) => {
		if (oemEntry?.display?.length) {
			let rowsForOem = [];
			let displayRows = [];
			oemEntry?.display?.forEach?.((row) => {
				if (row?.isFooter && obj?.oems?.length > 1) {
					displayRows.push({
						...row,
						subFooter: true,
					});
				} else {
					displayRows.push(row);
				}
			});
			rowsForOem = [...rowsForOem, ...displayRows];
			if (index !== obj?.oems?.length - 1) {
				rowsForOem.push({
					emptyRow: true,
				});
				rowsForOem.push({ emptyRow: true });
			}
			rows = [...rows, ...rowsForOem];
		}
	});

	let newRows = [];
	rows?.forEach?.((row) => {
		let rowToBuild = {};
		Object.entries(row || {})?.forEach?.(([objectKey, objectValue]) => {
			if (!isObject(objectValue)) {
				rowToBuild[objectKey] = objectValue;
			} else if (Array.isArray(objectValue)) {
				rowToBuild[objectKey] = objectValue;
			} else {
				let sum = 0;
				// eslint-disable-next-line no-unused-vars
				Object.entries(objectValue || {})?.forEach?.(([key, value]) => {
					sum += +(value || 0);
				});
				rowToBuild[objectKey] = sum;
			}
		});
		newRows.push(rowToBuild);
	});
	let newRowCount = Number(0);
	newRows.forEach((row) => {
		if (!row?._id) {
			row._id = "oem" + "-" + newRowCount++;
		}
		if (row?.id) {
			row.id = row._id;
		}
	});
	return newRows;
};
